import {Component, OnInit, ViewChild} from '@angular/core';
import { SectionBase } from '../../../components/section/section-base';
import { InstallmentSectionConfig } from './installment-section.config';
import { RegistrationService } from '../../../../core/services/impl/registration.service';
import { TranslateService } from '@ngx-translate/core';
import {OfferModificationsService} from '../../../../core/services/impl/offer-modifications/offer-modifications.service';
import {
  InstallmentStateService,
  InstallmentTileData
} from '../../../../core/services/impl/section-services/installment/installment-state.service';
import {RadioCheckboxTileComponent} from '../../../components/fields/radio-checkbox-tile/radio-checkbox-tile.component';
import {OfferService} from '../../../../core/services/impl/offer.service';

@Component({
  selector: 'app-installment-section',
  templateUrl: './installment-section.component.html',
  styleUrls: ['./installment-section.component.scss']
})
export class InstallmentSectionComponent extends SectionBase implements OnInit {

  @ViewChild('radioCheckboxTileComponent') radioCheckboxTileComponent: RadioCheckboxTileComponent;
  installmentConfig = new InstallmentSectionConfig(this.stateService, this.ts);
  sectionVisible = true;
  installmentTilesData: InstallmentTileData[];

  constructor(private stateService: InstallmentStateService,
              private ts: TranslateService,
              private offerModificationsService: OfferModificationsService,
              private registration: RegistrationService,
              private offerService: OfferService) {
    super();
  }

  ngOnInit() {
    this.init();
    this.offerModificationsService.modifiedOfferEvent.subscribe(() => this.rebuildSection());

    const subscription = this.offerService.getOfferEvent.subscribe(event => {
      subscription.unsubscribe();
      this.rebuildSection();
    });
  }

  initBean(): void {
    this.bean = {
      [this.installmentConfig.PREMIUM_ID]: this.stateService.premiumId
    };
  }

  createConfig(): void {
    this.formConfig = this.installmentConfig.createConfig();
  }

  initControlsChanges(): void {
    this.handleControlsState({
      controlName: this.installmentConfig.PREMIUM_ID, behaviour: value => {
        this.registration.premiumId = value;
        this.offerModificationsService.handleSelectedPremium(value);
      }
    })
  }

  fillForm(stepKey: string) {
    const key = this.installmentConfig.PREMIUM_ID;
    const fieldConfig = this.formConfig.fieldsConfig.filter(item => item.fieldKey === key);
    if (fieldConfig.length) {
      const value = fieldConfig[0].radioConfig[0].value;
      this.getControl(key).setValue(value);
    }
  }

  private init(): void {
    this.createConfig();
    this.initBean();
    this.buildForm();
    this.installmentTilesData = this.stateService.createTilesData();

    this.initControlsChanges();
    setTimeout(() => this.registration.setCaption(), 0);
  }

  private rebuildSection(): void {
    this.sectionVisible = false;
    this.installmentConfig = new InstallmentSectionConfig(this.stateService, this.ts);
    this.init();
    this.sectionVisible = true;
    if (this.radioCheckboxTileComponent) {
      this.radioCheckboxTileComponent.control.setValue(this.stateService.premiumId);
    }
  }
}

